const locale = {
    placeholder: 'Vaqtni tanlang',
    rangePlaceholder: ['Boshlanish vaqti', 'Tugallanish vaqti'],
};
export default locale;
